<script lang="ts" module>
  import type { LinkStoryblok } from '~/component-types-sb';
  import { page } from '$app/state';

  export interface FooterLinkProps {
    blok: LinkStoryblok;
  }
</script>

<script lang="ts">
  import { FooterLink } from '@agapi/ui/footer';
  import { storyblokEditable } from '@storyblok/svelte';
  import { rewriteUrl } from '../../../../utils';

  const { blok }: FooterLinkProps = $props();
</script>

<FooterLink href={rewriteUrl(page, blok?.path)} use={[[storyblokEditable, blok]]}>
  {blok.label || ''}
</FooterLink>
